<template>
  <div class="d-flex flex-wrap justify-content-start">
    <el-input v-model="search" clearable :placeholder="$t('placeholder.search_ral')" class="mx-2 mb-3" />
    <div
      v-for="color in splitColor"
      :key="color.ID"
      :style="{ background: rgbToHex(color.RGBCODE) }"
      class="color-square m-1 rounded"
      :class="{ 'is-active': isActive(color) }"
      @click="onColorSelect(color)"
    ></div>
    <el-button
      v-if="loadedColors < colors.length && widthWindow < 500 && !search"
      class="btnBottom"
      @click="loadedColors = loadedColors + 25"
    >
      {{ $t('general.more') }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'ColorSquarePicker',
  components: {},
  props: {
    colors: {
      type: Array,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.widthWindow = window.outerWidth;
  },
  destroyed() {},
  data() {
    return {
      loadedColors: 25,
      widthWindow: null,
      search: '',
    };
  },
  computed: {
    splitColor() {
      if (this.search) {
        return this.colors.filter((el) => el.RALCODE.includes(this.search));
      }
      if (this.widthWindow < 500) {
        return this.colors.slice(0, this.loadedColors);
      }

      return this.colors;
    },
  },
  methods: {
    rgbToHex(rgb) {
      let val = rgb.split(',');
      let r = parseInt(val[0]);
      let g = parseInt(val[1]);
      let b = parseInt(val[2]);
      return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    onColorSelect(color) {
      if (color.code !== undefined) {
        this.$emit('input', { name: color.NAME, hex: this.rgbToHex(color.RGBCODE), code: color.code });
      } else if (color.RALCODE !== undefined)
        this.$emit('input', { name: color.NAME, hex: this.rgbToHex(color.RGBCODE), code: color.RALCODE });
      else this.$emit('input', { name: color.NAME, hex: this.rgbToHex(color.RGBCODE) });
    },
    isActive(color) {
      if (!this.value) return false;

      return this.value.name === color.NAME;
    },
  },
};
</script>

<style lang="scss" scoped>
.color-square {
  width: 45px;
  min-width: 45px;
  max-width: 45px;
  height: 45px;
  cursor: pointer;
  transition: all ease-in-out 0.25s;
  border: 2px solid lightgray;
}

.is-active {
  border-radius: 100% !important;
}

.color-grid {
  display: grid;
  grid-auto-flow: column;
}
.btnBottom {
  position: relative;
  bottom: 0px;
}
</style>
